<template>
  <transition name="animation" >
    <div class="platform__ticker-body">
      <div class="platform__ticker">
        <div class="platform__ticker-symbol">{{group.symbol}}</div>
        <div class="platform__ticker-name" :title="group.tickerName">{{group.tickerName}}</div>
        <div class="platform__counter">
          <div class="platform__counter-text" :title="notificationsCount">{{notificationsCount > 99 ? '99+' : notificationsCount}}</div>
        </div>
        <div class="platform__cost">{{group | getObjPropInSelectedCurrencyBySign('price', notification.alertCurrencySign) | formatMoneyBySign(notification.alertCurrencySign)}}</div>
        <table class="platform__percents">
          <tr>
            <td class="platform__change-label">24H</td>
            <td class="platform__change-percent">{{group.percentChange24h | beautifyPercentValue}}%</td>
          </tr>
          <tr>
            <td class="platform__change-label">7D</td>
            <td class="platform__change-percent">{{group.percentChange7d | beautifyPercentValue}}%</td>
          </tr>
        </table>
        <div class="platform__center-circle">
          <div class="platform__create-date">{{notification.createdAt | formatTimeAgoShort}}</div>
          <div class="platform__create-date-label">ago</div>
          <div class="platform__parameter">{{notification.valueType | beautifyValueType}}</div>
          <!-- notification.alertCurrencySign -->
          <div class="platform__value" v-flexText>{{notification.targetDelta | beautifyTargetDeltaValueWithUnitsBySign(notification.alertType, notification.alertCurrencySign)}}</div>
          <icon-tendency-arrow :up="!arrowDown" class="platform__tendency-arrow"/>
          <div class="platform__tendency">{{ arrowDown ? 'decrease' : 'increase'}}</div>
        </div>
        <div class="platform__value-change">
          <div class="platform__value-change_before">{{notification.baseValue | formatMoneyBySign(notification.alertCurrencySign)}}</div>
          <div class="platform__value-change-arrow"></div>
          <div class="platform__value-change_after">{{notification.targetValue | formatMoneyBySign(notification.alertCurrencySign)}}</div>
        </div>
      </div>
      <div class="platform__close-block">
        <button class="platform__close disable-btns-rules" :disabled="disableBtns" @click="closeNotificationWrapper">
          Close
          <icon-base v-if="!closingNotificationInProgress" red class="platform__cross">
            <icon-cross />
          </icon-base>
        </button>
        <button class="platform__close platform__close_all disable-btns-rules" :disabled="disableBtns" @click="closeGroupNotificationWrapper">
          Close all
          <icon-base v-if="!closingGroupNotificationsInProgress" red class="platform__cross">
            <icon-cross/>
          </icon-base>
        </button>
        <button class="platform__close platform__archive disable-btns-rules" :disabled="disableBtns" @click="openArchiveNotificationModal({group, notification})">
          Archive alert
          <icon-base v-if="!archivingInProgress" red class="platform__archive-icon">
            <icon-archive/>
          </icon-base>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { IconCross, IconArchive, IconTendencyArrow } from 'Icons';
import {
  formatTimeAgoShort,
  formatMoney,
  beautifyPercentValue,
  beautifyValueType,
  beautifyTargetDeltaValueWithUnits,
  getCurrencyCodeBySign,
  getObjPropInSelectedCurrency,
} from 'src/utils/helpers';

export default {
  props: {
    notification: Object,
    group: Object,
    notificationsCount: Number,
    active: Boolean,
  },
  data: () => ({
    closingNotificationInProgress: false,
    closingGroupNotificationsInProgress: false,
  }),
  components: {
    IconCross,
    IconArchive,
    IconTendencyArrow,
  },
  directives: {
    flexText: {
      inserted(el) {
        /* eslint-disable no-param-reassign */
        const maxFontSize = 48;
        const minFontSize = 6;
        let currentFontSize = maxFontSize;
        el.style.fontSize = maxFontSize;
        while (el.offsetHeight > 1 && currentFontSize > minFontSize) {
          el.style.overflowWrap = 'break-word';
          el.style.lineHeight = '1px';
          currentFontSize -= 1;
          el.style.fontSize = `${currentFontSize}px`;
        }
        el.style.lineHeight = null;
        el.style.overflowWrap = null;
        /* eslint-enable */
      },
    },
  },
  filters: {
    formatTimeAgoShort,
    beautifyPercentValue,
    beautifyValueType,
    getObjPropInSelectedCurrencyBySign(obj, prop, sign) {
      return getObjPropInSelectedCurrency(obj, prop, getCurrencyCodeBySign(sign));
    },
    beautifyTargetDeltaValueWithUnitsBySign(value, alertType, sign) {
      return beautifyTargetDeltaValueWithUnits(value, alertType, getCurrencyCodeBySign(sign));
    },
    formatMoneyBySign(value, sign) {
      return formatMoney(value, getCurrencyCodeBySign(sign));
    },
  },
  methods: {
    ...mapActions('platformNotifications', [
      'updatePlatformNotifications',
      'openArchiveNotificationModal',
      'closeNotification',
      'closeGroupNotifications',
    ]),
    closeNotificationWrapper() {
      this.closingNotificationInProgress = true;
      this.closeNotification(this.notification).finally(() => {
        this.updatePlatformNotifications().finally(() => {
          this.closingNotificationInProgress = false;
        });
      });
    },
    closeGroupNotificationWrapper() {
      this.closingGroupNotificationsInProgress = true;
      this.closeGroupNotifications(this.group).finally(() => {
        this.updatePlatformNotifications().finally(() => {
          this.closingGroupNotificationsInProgress = false;
        });
      });
    },
  },
  computed: {
    ...mapState('platformNotifications', [
      'archivingInProgress',
    ]),
    ...mapGetters('userData', ['currencyCode']),
    disableBtns() {
      return this.closingNotificationInProgress || this.closingGroupNotificationsInProgress
        || this.archivingInProgress;
    },
    arrowDown() {
      return this.notification.directionOfChange === 'down';
    },
  },
};
</script>


<style lang="scss" scoped>
  .platform {
    position: fixed;
    z-index: 10001;
    margin-left: -$closed-sidepanel-width;
    display: flex;
    width: 100%;
    height: 100%;
    background: $black-color11;
    &__ticker {
      background: url("~src/assets/svg/platformNotificationCircles.svg") $red-color3 -1px 0 no-repeat;
      display: flex;
      width: 310px;
      height: 335px;
      border-radius: 10px;
      z-index: 3;
      position: relative;
    }
    &__ticker-body {
      transition: margin-top, opacity, $transition/2, transform $transition*2;
      position: relative;
      z-index: 3;
      top: 50%;
      margin-top: -168px;
      position: absolute;
      left: 50%;
      margin-left: -155px;
      &:nth-child(2) {
        z-index: 2;
        opacity: .7;
        transform: scale3d(0.9, 0.9, 0.9);
        margin-top: -141px;
        .platform__close-block,
        .platform__counter {
          opacity: 0;
          pointer-events: none;
        }
      }
      &:nth-child(3) {
        z-index: 1;
        opacity: .5;
        transform: scale3d(0.8, 0.8, 0.8);
        margin-top: -115px;
        .platform__close-block,
        .platform__counter {
          opacity: 0;
          pointer-events: none;
        }
      }
    }
    &__archive {
      height: 14px;
    }
    &__ticker-symbol {
      @include font(28px, $white-color2, bold);
      position: absolute;
      left: 22px;
      top: 22px;
    }
    &__ticker-name {
      @include font(10px, $red-color9, 500);
      @include trimOverflowText(112px);
      text-transform: uppercase;
      position: absolute;
      left: 22px;
      top: 55px;
    }
    &__counter {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      background: $red-color3;
      box-shadow: 5px 5px 40px $red-color9;
      position: absolute;
      right: -29px;
      top: -30px;
      display: flex;
      line-height: 60px;
      text-align: center;
    }
    &__counter-text {
      @include font(28px, $white-color2);
      margin: auto;
    }
    &__center-circle {
      border-radius: 50%;
      width: 200px;
      height: 200px;
      position: relative;
      top: 10px;
      background: $red-color9;
      margin: auto;
      text-align: center;
    }
    &__create-date {
      @include font(21px, $red-color3, bold);
      text-transform: uppercase;
      margin-top: 19px;
    }
    &__create-date-label {
      @include font(10px, $red-color3, 600);
      margin-top: -1px;
    }
    &__parameter {
      @include font(10px, $white-color2, 600);
      text-transform: uppercase;
      margin-top: 20px;
    }
    &__value {
      @include font(48px, $white-color2, 300);
      margin-top: -1px;
      margin-left: 8px;
    }
    &__tendency {
      @include font(10px, $white-color2, 600);
      margin-top: 7px;
      margin-left: 2px;
    }
    &__tendency-arrow {
      margin-top: 15px;
      transform: scale3d(2.6, 2.6, 2.6);
    }
    &__cost {
      @include font(21px, $white-color2, 500);
      position: absolute;
      top: 25px;
      right: 21px;
    }
    &__percents{
      position: absolute;
      text-align: right;
      top: 53px;
      right: 21px;
    }
    &__change-label {
      @include font(11px, $red-color9, bold);
    }
    &__change-percent {
      @include font(11px, $white-color2, 500);
    }
    &__value-change {
      position: absolute;
      bottom: 24px;
      width: 100%;
      text-align: center;
      &_before {
        display: inline-block;
        @include font(11px, $white-color2, 500);
      }
      &_after {
        display: inline-block;
        @include font(11px, $white-color2, 500);
      }
    }
    &__value-change-arrow {
      display: inline-block;
      margin: 0 11px;
      background: url("~src/assets/svg/platformNotificationArrow.svg");
      width: 18px;
      height: 8px;
    }

    &__close {
      @include removeBtnDefaults;
      display: block;
      @include font(11px, $white-color2, bold);
      text-transform: uppercase;
      cursor: pointer;
      transition: opacity $transition;
      &[disabled] {
        opacity: .7;
        cursor: not-allowed !important
      }
    }
    &__cross {
      transform: scale3d(0.8, 0.8, 0.8);
      display: inline-block;
      vertical-align: bottom;
      margin-left: 4px;
    }
    &__archive-icon {
      left: 5px;
      position: relative;
    }
    &__close-block {
      position: absolute;
      right: -134px;
      top: 128px;
      width: 116px;
      height: 107px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
    }
  }

  .animation-leave-active {
    transform: scale3d(1.5, 1.5, 1.5);
    opacity: 0;
    transition: $transition/1.5;
  }

  .group_blur {
    .platform__counter,
    .platform__close-block {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlatformNotifications/PlatformNotification.vue